import React from 'react';
import { Trophy, ArrowRight, Instagram, Twitter, MessageCircle, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom'; // 1. Added Link import

const Footer = () => {
  return (
    <footer className="relative bg-black pt-32 pb-10 overflow-hidden border-t border-white/5">
      {/* Background Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#D4AF37]/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        
        {/* THE FINAL CTA */}
        <div className="flex flex-col items-center text-center mb-24">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="mb-8 text-[#D4AF37]"
          >
            <Trophy size={48} strokeWidth={1} />
          </motion.div>
          
          <h2 className="text-4xl md:text-6xl font-black italic uppercase tracking-tighter mb-8">
            Partner with <span className="text-[#D4AF37]">Excellence</span>
          </h2>
          <p className="text-white/40 text-xs md:text-sm tracking-[0.4em] uppercase mb-12 max-w-2xl leading-loose">
            Align your brand with the most prestigious <br /> talent event in the region.
          </p>
          
          <button className="group flex items-center gap-6 border border-[#D4AF37] text-[#D4AF37] px-12 py-5 text-[10px] font-black tracking-[0.5em] uppercase hover:bg-[#D4AF37] hover:text-black transition-all duration-700">
            Sponsorship Prospectus <ArrowRight size={16} className="group-hover:translate-x-2 transition-transform" />
          </button>
        </div>

        {/* BRANDING & SOCIALS */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-16 border-t border-white/5 gap-12">
          <div className="text-center md:text-left">
            <div className="text-3xl font-black italic tracking-tighter uppercase mb-3">
              MZINYI <span className="text-[#D4AF37]">2026</span>
            </div>
            <p className="text-[10px] tracking-[0.4em] text-white/20 uppercase font-bold italic">
              Excellence lives here.
            </p>
          </div>

          {/* 2. ADDED LEGAL & SUPPORT LINKS HERE */}
          <div className="flex flex-col items-center md:items-end gap-4">
             <div className="flex gap-8">
                <Link to="/legal" className="text-[9px] font-black uppercase text-white/40 hover:text-[#D4AF37] transition-all tracking-widest">
                    Privacy & Terms
                </Link>
                <a href="mailto:mzinyiawards@gmail.com" className="text-[9px] font-black uppercase text-white/40 hover:text-[#D4AF37] transition-all tracking-widest">
                    Support
                </a>
             </div>
             <div className="flex gap-10 mt-2">
                {/*<a href="#" className="text-white/20 hover:text-[#D4AF37] transition-colors"><Instagram size={18} /></a>
                <a href="#" className="text-white/20 hover:text-[#D4AF37] transition-colors"><Twitter size={18} /></a>
                <a href="#" className="text-white/20 hover:text-[#D4AF37] transition-colors"><MessageCircle size={18} /></a>*/}
             </div>
          </div>
        </div>

        {/* CLEAN COPYRIGHT & TECH PARTNER */}
        <div className="text-center mt-24 pt-12 border-t border-white/5">
          <p className="text-[9px] tracking-[0.5em] text-white/40 uppercase font-bold">
            &copy; 2026 MZINYI TAITA TAVETA AWARDS.
          </p>
          
          <div className="flex flex-col items-center gap-2 mt-8">
              <div className="flex items-center gap-3">
                  <div className="h-[1px] w-8 bg-white/10"></div>
                  <ShieldCheck size={12} className="text-[#D4AF37]/50" />
                  <p className="text-[8px] font-bold text-white/20 uppercase tracking-[0.3em]">Official Technology Provider</p>
                  <div className="h-[1px] w-8 bg-white/10"></div>
              </div>
              <p className="text-[10px] font-black uppercase tracking-[0.2em] text-[#D4AF37] italic">
                INICUS <span className="text-white/60">INNOVATIONS LIMITED</span>
              </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

















/*import React from 'react';
import { Trophy, ArrowRight, Instagram, Twitter, MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="relative bg-black pt-32 pb-10 overflow-hidden border-t border-white/5">
      {/* Background Glow *//*
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#D4AF37]/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        
        {/* THE FINAL CTA *//*
        <div className="flex flex-col items-center text-center mb-24">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="mb-8 text-[#D4AF37]"
          >
            <Trophy size={48} strokeWidth={1} />
          </motion.div>
          
          <h2 className="text-4xl md:text-6xl font-black italic uppercase tracking-tighter mb-8">
            Partner with <span className="text-[#D4AF37]">Excellence</span>
          </h2>
          <p className="text-white/40 text-xs md:text-sm tracking-[0.4em] uppercase mb-12 max-w-2xl leading-loose">
            Align your brand with the most prestigious <br /> talent event in the region.
          </p>
          
          <button className="group flex items-center gap-6 border border-[#D4AF37] text-[#D4AF37] px-12 py-5 text-[10px] font-black tracking-[0.5em] uppercase hover:bg-[#D4AF37] hover:text-black transition-all duration-700">
            Sponsorship Prospectus <ArrowRight size={16} className="group-hover:translate-x-2 transition-transform" />
          </button>
        </div>

        {/* BRANDING & SOCIALS *//*
        <div className="flex flex-col md:flex-row justify-between items-center pt-16 border-t border-white/5 gap-12">
          <div className="text-center md:text-left">
            <div className="text-3xl font-black italic tracking-tighter uppercase mb-3">
              MZINYI <span className="text-[#D4AF37]">2026</span>
            </div>
            <p className="text-[10px] tracking-[0.4em] text-white/20 uppercase font-bold">
              Excellence lives here. Curated by TTPCA.
            </p>
          </div>

          <div className="flex gap-10">
            <a href="#" className="text-white/40 hover:text-[#D4AF37] transition-colors"><Instagram size={22} /></a>
            <a href="#" className="text-white/40 hover:text-[#D4AF37] transition-colors"><Twitter size={22} /></a>
            <a href="#" className="text-white/40 hover:text-[#D4AF37] transition-colors"><MessageCircle size={22} /></a>
          </div>
        </div>

        {/* CLEAN COPYRIGHT *//*
        <div className="text-center mt-24">
          <p className="text-[9px] tracking-[0.5em] text-white uppercase font-bold">
            &copy; 2026 MZINYI TAITA TAVETA AWARDS. ALL RIGHTS RESERVED.
          </p>
            <p className="text-[7px] font-black uppercase tracking-[0.3em] text-[#D4AF37]/40 mt-4">
        Technology Partner: <span className="text-[#D4AF37]/80">INICUS INNOVATIONS LIMITED</span>
    </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;*/